import { render, staticRenderFns } from "./PlaneCanvas.vue?vue&type=template&id=5d711572&scoped=true&"
import script from "./PlaneCanvas.vue?vue&type=script&lang=js&"
export * from "./PlaneCanvas.vue?vue&type=script&lang=js&"
import style0 from "./PlaneCanvas.vue?vue&type=style&index=0&id=5d711572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d711572",
  null
  
)

export default component.exports